var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "portlet light portlet-fit timesheet-wrapper",
      staticStyle: { "min-width": "1400px", "overflow-x": "auto" }
    },
    [
      _c("div", { staticClass: "portlet-title d-flex" }, [
        _c(
          "div",
          { staticClass: "caption mr-auto" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm.timesheet != null
              ? [
                  _vm.timesheet.timesheet_status == "0"
                    ? _c(
                        "span",
                        { staticClass: "badge bg-green-jungle bold" },
                        [
                          _c("i", { staticClass: "fa fa-edit" }),
                          _vm._v(" Brouillon")
                        ]
                      )
                    : _vm.timesheet.timesheet_status == "1"
                    ? _c("span", { staticClass: "badge bg-yellow-gold bold" }, [
                        _c("i", { staticClass: "fa fa-clock-o" }),
                        _vm._v(" En approbation")
                      ])
                    : _vm.timesheet.timesheet_status == "2"
                    ? _c("span", { staticClass: "badge bg-red bold" }, [
                        _c("i", { staticClass: "fa fa-check" }),
                        _vm._v(" Approuvée")
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _c("br"),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sortOrder,
                    expression: "sortOrder"
                  }
                ],
                staticClass: "form-control mt-1",
                staticStyle: { width: "auto" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.sortOrder = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.loadTimesheet
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("Ordre de trie...")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "project_number" } }, [
                  _vm._v("Numéro de projet")
                ])
              ]
            )
          ],
          2
        ),
        _vm._v(" "),
        _vm.timesheet != null
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "text-center",
                  staticStyle: { "font-size": "22px" }
                },
                [_vm._v(_vm._s(_vm.timesheet.timesheet_employee_name))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c("week-picker", {
                    attrs: { value: _vm.startDate },
                    on: { change: _vm.handleChangeDate }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto d-flex flex-wrap" }, [
          _vm.timesheet != null
            ? _c(
                "div",
                [
                  _vm.timesheet.timesheet_status == "0"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn blue mr-1",
                          on: { click: _vm.sendTimesheetAsk }
                        },
                        [
                          _c("i", { staticClass: "fa fa-send" }),
                          _vm._v(" Envoyer pour approbation\n        ")
                        ]
                      )
                    : _vm.timesheet.timesheet_status == "1" && _vm.canApprove
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn green-jungle mr-1",
                            on: { click: _vm.approveTimesheetAsk }
                          },
                          [
                            _c("i", { staticClass: "fa fa-check" }),
                            _vm._v(" Approuver\n          ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn red mr-1",
                            on: { click: _vm.returnTimesheetAsk }
                          },
                          [
                            _c("i", { staticClass: "fa fa-times" }),
                            _vm._v(" Retourner\n          ")
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "portlet-body" }, [_vm._v(" Loading. ")])
        : _c(
            "div",
            { staticClass: "portlet-body" },
            [
              _c("timesheet-section", {
                attrs: {
                  rows: _vm.timeRows,
                  title: "Heures projets",
                  activityNameLabel: "Activité",
                  activityNumberLabel: "# Act",
                  activityType: "activity",
                  start: _vm.startDate,
                  end: _vm.endDate,
                  editMode: _vm.editMode,
                  rowType: "1",
                  valueDecimals: 2
                },
                on: { rowUpdated: _vm.rowUpdated, rowDeleted: _vm.deleteRow }
              }),
              _vm._v(" "),
              _c("timesheet-section", {
                attrs: {
                  rows: _vm.expenseRows,
                  title: "Dépenses",
                  activityNameLabel: "Dépense",
                  activityNumberLabel: "Type",
                  activityType: "expense",
                  start: _vm.startDate,
                  end: _vm.endDate,
                  editMode: _vm.editMode,
                  rowType: "2",
                  valueDecimals: 2,
                  commentText: "Incluant TPS et TVQ"
                },
                on: { rowUpdated: _vm.rowUpdated, rowDeleted: _vm.deleteRow }
              }),
              _vm._v(" "),
              _c("timesheet-section", {
                attrs: {
                  rows: _vm.milageRows,
                  title: "Kilométrage",
                  activityNameLabel: "",
                  activityNumberLabel: "",
                  start: _vm.startDate,
                  end: _vm.endDate,
                  editMode: _vm.editMode,
                  rowType: "3",
                  valueDecimals: 2,
                  displayActivityInputs: false
                },
                on: { rowUpdated: _vm.rowUpdated, rowDeleted: _vm.deleteRow }
              }),
              _vm._v(" "),
              _vm.timesheet != null
                ? _c("div", [
                    _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("timesheet-expense-totals", {
                              attrs: {
                                rows: _vm.rows,
                                tps: _vm.timesheet.timesheet_tps_value,
                                tvq: _vm.timesheet.timesheet_tvq_value,
                                kmRate: _vm.timesheet.timesheet_km_rate
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("timesheet-paid-hour-totals", {
                              attrs: {
                                rows: _vm.rows,
                                timesheet: _vm.timesheet,
                                allocation: {
                                  sicknessHours:
                                    _vm.timesheet
                                      .timesheet_start_sickness_hours,
                                  holidayHours:
                                    _vm.timesheet.timesheet_start_holiday_hours,
                                  vacationHours:
                                    _vm.timesheet
                                      .timesheet_start_vacation_hours,
                                  bankHours:
                                    _vm.timesheet.timesheet_start_bank_hours
                                },
                                editMode: _vm.editMode,
                                canAdjust:
                                  _vm.canApprove &&
                                  _vm.timesheet.timesheet_status == "1"
                              },
                              on: { adjustmentChanged: _vm.adjustmentChanged }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fa fa-clock-o" }),
      _vm._v(" Feuille de temps\n      ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }